module.exports = __webpack_public_path__ + "img/pd_C2.4 (_Dimension Characteristics_).b90f2da6.png";